// extracted by mini-css-extract-plugin
export default {"root":"MenuBarWin98_root__fUK8j"};